import type {
  SendSessionApplicationAcceptedInput,
  SendSessionApplicationAcceptedOutput,
  SendSpeakerGramInput,
  SendSpeakerGramOutput,
} from '@sunrise-ui/api/notifications';
import { useSnackbar } from '@sunrise-ui/primitives';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import { notificationsApi } from '../utils/api';

/**
 * Hook for sending session application accepted notifications to users
 * Uses the notifications service's send-session-application-accepted endpoint
 */
export const useSendSessionApplicationAccepted = () => {
  const { showSnackbar } = useSnackbar();

  return useMutation<
    AxiosResponse<SendSessionApplicationAcceptedOutput>,
    AxiosError,
    SendSessionApplicationAcceptedInput
  >({
    mutationFn: async (variables) => {
      return notificationsApi.sendSessionApplicationAcceptedEventsSendSessionApplicationAcceptedPost(
        {
          sendSessionApplicationAcceptedInput: variables,
        },
      );
    },
    onSuccess: () => {
      showSnackbar({
        text: 'Notification sent successfully',
        type: 'success',
      });
    },
    onError: (error) => {
      console.error('Error sending notification:', error);
      showSnackbar({
        text: 'Failed to send notification',
        type: 'error',
      });
    },
  });
};

/**
 * Hook for sending speaker gram notifications to users
 * Uses the notifications service's send-speaker-gram endpoint
 */
export const useSendSpeakerGram = () => {
  const { showSnackbar } = useSnackbar();

  return useMutation<
    AxiosResponse<SendSpeakerGramOutput>,
    AxiosError,
    SendSpeakerGramInput
  >({
    mutationFn: async (variables) => {
      return notificationsApi.sendSpeakerGramEventsSendSpeakerGramPost({
        sendSpeakerGramInput: variables,
      });
    },
    onSuccess: () => {
      showSnackbar({
        text: 'Speaker gram notifications sent successfully',
        type: 'success',
      });
    },
    onError: (error) => {
      console.error('Error sending speaker gram notifications:', error);
      showSnackbar({
        text: 'Failed to send speaker gram notifications',
        type: 'error',
      });
    },
  });
};
